module.exports = __webpack_public_path__ + "static/cs-wordmark-black-f35cfa971798910278bf8a05810d6ab1.png";